import type { ChatRoomMessage } from "@circle-react/types/Chat/ChatRoomMessage";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export interface BodyProps {
  currentCommunityMember?: {
    id: number;
  };
  draftText?: string;
  isDirect: boolean;
  lastMessage: ChatRoomMessage;
}
export const Body = ({
  isDirect,
  lastMessage,
  draftText,
  currentCommunityMember,
}: BodyProps) => {
  const getMessageSenderName = () => {
    if (
      lastMessage?.sender?.community_member_id === currentCommunityMember?.id
    ) {
      return `${t("messaging.you")}: `;
    }

    return isDirect ? "" : `${lastMessage.sender.name}: `;
  };

  const messageBody =
    lastMessage.body ||
    lastMessage.rich_text_body?.circle_ios_fallback_text ||
    "";

  return (
    <Typography
      variant="body-sm"
      color="tertiary"
      className="line-clamp-1 overflow-hidden hyphens-auto break-all text-left"
    >
      {draftText ? (
        <>
          <Typography variant="body-sm" color="danger" component="span">
            {`${t("messaging.draft")}:`}
          </Typography>{" "}
          {draftText}
        </>
      ) : (
        `${getMessageSenderName()}${messageBody}`
      )}
    </Typography>
  );
};
